import { Authority } from '@/shared/security/authority';
import entities from '@/router/entities';

const JhiUserManagementComponent = () => import('@/sections/admin/user-management/user-management.vue');
const JhiUserManagementViewComponent = () => import('@/sections/admin/user-management/user-management-view.vue');
const JhiUserManagementEditComponent = () => import('@/sections/admin/user-management/user-management-edit.vue');
const JhiLogsComponent = () => import('@/sections/admin/logs/logs.vue');
const JhiMetricsComponent = () => import('@/sections/admin/metrics/metrics.vue');

export default [
  {
    path: '/admin/user-management',
    name: 'JhiUser',
    component: JhiUserManagementComponent,
    meta: { authorities: [Authority.ADMIN] },
  },
  {
    path: '/admin/user-management/new',
    name: 'JhiUserCreate',
    component: JhiUserManagementEditComponent,
    meta: { authorities: [Authority.ADMIN] },
  },
  {
    path: '/admin/user-management/:userId/edit',
    name: 'JhiUserEdit',
    component: JhiUserManagementEditComponent,
    meta: { authorities: [Authority.ADMIN] },
  },
  {
    path: '/admin/user-management/:userId/view',
    name: 'JhiUserView',
    component: JhiUserManagementViewComponent,
    meta: { authorities: [Authority.ADMIN] },
  },
  {
    path: '/admin/logs',
    name: 'JhiLogsComponent',
    component: JhiLogsComponent,
    meta: { authorities: [Authority.ADMIN] },
  },
  {
    path: '/admin/metrics',
    name: 'JhiMetricsComponent',
    component: JhiMetricsComponent,
    meta: { authorities: [Authority.ADMIN] },
  },
  entities,
];
